import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureaddQuestions, successaddQuestions } from "./AddQuestionsSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  IQuestions,
  IQuestionsData,
} from "../../../Pages/Questions/IQuestions";

import {
  failuredeleteQuestions,
  successdeleteQuestions,
} from "./DeleteQuestionsSlice";
import {
  failurelistQuestions,
  successlistQuestions,
} from "./ListQuestionsSlice";
import {
  failureEditQuestions,
  successEditQuestions,
} from "./EditQuestionsSlice";

// list
const ListQuestionsApi = (action: PayloadAction<any>) => {
  const { page, page_size, ...body } = action.payload;
  return api.post(
    "/api/question/",
    body, // request body
    {
      params: { page, page_size }, // query parameters
    }
  );
};

export function* ListQuestionsCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(ListQuestionsApi, action);
    yield put(successlistQuestions(response.data));
  } catch (error) {
    yield put(failurelistQuestions(error));
  }
}

// add
const AddQuestionsApi = (action: PayloadAction<IQuestions>) => {
  const formData = new FormData();
  formData.append("options", JSON.stringify(action.payload.options));
  action.payload.question_url &&
    formData.append("question_url", action.payload.question_url);
  action.payload.prompt_url &&
    formData.append("prompt_url", action.payload.prompt_url);
  console.log(action.payload.yeargroup_region);

  if (action.payload.option_url) {
    action.payload.option_url.forEach((img) => {
      formData.append("option_url", img.option_url);
    });
  }

  if (action.payload.yeargroup_region) {
    // If year_levels is an array or object, stringify it
    formData.append(
      "yeargroup_region",
      JSON.stringify(action.payload.yeargroup_region)
    );
  }
  if (action.payload.answer_type) {
    formData.append("answer_type", action.payload.answer_type);
  }
  if (action.payload.drag_drop_pattern) {
    formData.append("drag_drop_pattern", action.payload.drag_drop_pattern);
  }
  if (action.payload.drag_drop_data) {
    formData.append("drag_drop_data", JSON.stringify(action.payload.drag_drop_data));
  }
  return api.post("/api/question/add-question", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },

    params: {
      questionType: action.payload.questionType,
      subType: action.payload.subType,
      // year_level: "Year 5",
      prompt: action.payload.prompt,
      main: action.payload.main,
      free_tier: action.payload.free_tier,
      grouped_question: action.payload.grouped_question,
      question: action.payload.question,
      instruction: action.payload.instruction,
      explanation: action.payload.explanation,
      // difficulty_level: action.payload.difficulty_level,
      // year_level: action.payload.year_level,
      source_type: action.payload.source_type,
      Status: action.payload.Status,
    },
  });
};

export function* AddQuestionsCall(action: PayloadAction<IQuestions>) {
  try {
    const response: AxiosResponse = yield call(AddQuestionsApi, action);
    yield put(successaddQuestions(response.data));
  } catch (error) {
    yield put(failureaddQuestions(error));
  }
}

// edit
const EditQuestionsApi = (action: PayloadAction<IQuestions>) => {
  const formData = new FormData();
  formData.append("options", JSON.stringify(action.payload.options ?? null));
  action.payload.question_url &&
    formData.append("question_url", action.payload.question_url);
  action.payload.prompt_url &&
    formData.append("prompt_url", action.payload.prompt_url);
  // formData.append("yeargroup_region", action.payload.yeargroup_region);

  if (action.payload.option_url) {
    action.payload.option_url.forEach((img) => {
      formData.append("option_url", img.option_url);
    });
  }

  if (action.payload.yeargroup_region) {
    // If year_levels is an array or object, stringify it
    formData.append(
      "yeargroup_region",
      JSON.stringify(action.payload.yeargroup_region)
    );
  }
  if (action.payload.answer_type) {
    formData.append("answer_type", action.payload.answer_type);
  }
  if (action.payload.drag_drop_pattern) {
    formData.append("drag_drop_pattern", action.payload.drag_drop_pattern);
  }
  if (action.payload.drag_drop_data) {
    formData.append("drag_drop_data", JSON.stringify(action.payload.drag_drop_data));
  }
  return api.put("/api/question/update/", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: {
      id: action.payload.id,
      questionType: action.payload.questionType,
      subType: action.payload.subType,
      prompt: action.payload.prompt,
      year_level: action.payload.yeargroup_region,

      main: action.payload.main,
      free_tier: action.payload.free_tier,
      grouped_question: action.payload.grouped_question,
      question: action.payload.question,
      instruction: action.payload.instruction,
      explanation: action.payload.explanation,
      // difficulty_level: action.payload.difficulty_level,
      // year_level: action.payload.year_level,
      source_type: action.payload.source_type,
      Status: action.payload.Status,
      imgWidth: action.payload.imgWidth,
      prompt_imgWidth: action.payload.promptImgWidth,
    },
  });
};

export function* EditQuestionsCall(action: PayloadAction<IQuestions>) {
  try {
    const response: AxiosResponse = yield call(EditQuestionsApi, action);
    yield put(successEditQuestions(response.data));
  } catch (error) {
    yield put(failureEditQuestions(error));
  }
}

// delete
const DeleteQuestionsApi = (action: PayloadAction<number>) => {
  return api.delete("/api/question/delete/", {
    params: { id: action.payload },
  });
};

export function* DeleteQuestionsCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteQuestionsApi, action);
    yield put(successdeleteQuestions(response.data));
  } catch (error) {
    yield put(failuredeleteQuestions(error));
  }
}
